import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { CategorizationService } from 'src/app/services/categorization.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-configuration-access',
  templateUrl: './configuration-access.component.html',
  styleUrls: ['./configuration-access.component.css']
})
export class ConfigurationAccessComponent implements ICellEditorAngularComp, AfterViewInit {

  private params: any;
  public selectedValues: any[] = [];
  public options: any[] = [];
  public dependentCols: any;
  projectId: any;
  public businessAreaId: number;
  public businessLineId: number;
  Standdata: any;
  cellWidth: number = 80;
  value: any;
  //localStorageService: any;
  @ViewChild(MatSelect) matSelect: MatSelect;

  constructor(
    private confService: ConfigurationService,
    // private projectService: ProjectService,
    private localStorageService: LocalStorageService,
    public dialog: MatDialog,
  ) { }

  agInit(params: any): void {
    this.projectId = this.localStorageService.get("projectId");
    this.params = params;
    this.cellWidth = params?.column?.actualWidth || 80; // get cell width from params
    this.confService.GetAllConfigurationForAccess(this.projectId).subscribe((ConfigurationData: any) => {
      let errorMsgeFromBack = ConfigurationData.Data.Message;
      if (ConfigurationData.StatusCode == 200) {

        this.options = ConfigurationData.Data;

        this.selectedValues = params.data.ConfigurationName;

        // columns to clear when this select changes
        this.dependentCols = ['Assemblies']; // <-- set this to your actual field names

        setTimeout(() => {
          this.matSelect?.open();
        }, 0);
      }
      else {
        //Show errorCode and errorMessage in the UI
        let errorContainer = [
          { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
          { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
        ]
        this.openAlertDialog(errorContainer);
      }
    }, (error) => {
      //Show errorCode and errorMessage in the UI
      this.openAlertDialog([{ [serverMessage.serverAPIerror]: serverMessage.serverErrorHeader }]);
    });
  }
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }

  getValue(): any {
    return this.selectedValues;
  }

  // onChange(event: any): void {
  //   this.value = event.value;
  // }

  onOpenedChange(opened: boolean) {
    // console.log("hello");
    if (!opened) {
      this.params.api.stopEditing();
    }
  }

  isPopup(): boolean {
    return true;
  }
  compareItems(item1: any, item2: any): boolean {
    return item1 && item2 && item1.ID == item2.ID;
  }

  ngAfterViewInit() {
    // Open the dropdown after the view is initialized

  }

  onSelectionChange(newValue: any) {
    // If you’re storing the whole object, you might want just its ID:
    // const configId = newValue?.ConfigurationId ?? null;

    // Update the current field (if needed)
    // this.params.node.setDataValue('primary', configId); // or the field name for this column

    // Clear dependent dropdowns
    this.dependentCols.forEach(colId => {
      this.params.node.setDataValue(colId, null);
    });

    // Optional: force refresh to reflect immediate UI changes
    this.params.api.refreshCells({
      rowNodes: [this.params.node],
      columns: this.dependentCols,
      force: true
    });
  }

}
